import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '@thd-nucleus/app-render';
import { Typography, Link } from '@one-thd/sui-atomic-components';
import { useSummaryStore } from '@src/stores/summaryStore';
import { useReturnStore } from '@src/stores/returnStore';
import { getSimplifiedDate, getWindow, isFeatureSwitchEnabled, } from '@src/utils/general';
import { checkTHDConsumerVersion, getMobileOSAndVersion, } from '@src/utils/mobile';
import PrintReturnLabel from '@src/components/print-return-label/PrintReturnLabel';
import { PRINT_LABEL_MINIMUM_VERSION } from '@src/constants/fs-values';
import { executePrintShippingLabel } from '@src/utils/printReturnLabelUtil';
import { REFUND_TIMING_MESSAGE, RETURN_SUMMARY, RETURN_SUMMARY_LEGACY, } from '@src/constants';
import ViewUPSBarcodeButton from '@src/components/view-ups-barcode/ViewUpsBarcodeButton';
import SummaryStep from './SummaryStep';
import MultiAddressBarcodes from './multi-address/MultiAddressBarcodes';
export var UPSNextSteps = function () {
    var _a, _b, _c;
    var navigate = useNavigate();
    var instance = useContext(AppContext).instance;
    var _d = useSummaryStore(function (state) { return state; }), orderId = _d.orderId, emailId = _d.emailId, _e = _d.returnTrackingNumbers, returnTrackingNumbers = _e === void 0 ? [] : _e, trackingDetails = _d.trackingDetails, returnByDate = _d.returnByDate;
    var orderDetailsV2 = useReturnStore(function (state) { return state.orderDetailsV2; });
    var militaryExchange = useReturnStore(function (state) { return state.militaryExchange; });
    var isMilitaryExchangeGuest = useReturnStore(function (state) { return state.isMilitaryExchangeGuest; });
    var isMultiAddressReturn = useSummaryStore(function (state) { return state.isMultiAddressReturn; });
    var shipments = useSummaryStore(function (state) { return state.shipments; });
    var orderDetailsPath = useReturnStore(function (state) { return state.orderDetailsPath; });
    var simplifiedReturnByDate = getSimplifiedDate(returnByDate);
    var isNativeApp = ((_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.__EXPERIENCE_CONTEXT__) === null || _b === void 0 ? void 0 : _b.isConsumerApp) || false;
    var allowNativeAppShippingLabel = isFeatureSwitchEnabled(instance, 'allowNativeAppShippingLabel');
    var isUPSBarcodeEnabled = isFeatureSwitchEnabled(instance, 'enableUPSBarcode');
    var appInfo = getMobileOSAndVersion();
    var isSufficientVersion = checkTHDConsumerVersion(appInfo.version, PRINT_LABEL_MINIMUM_VERSION[appInfo.os]);
    var returnToInitialPage = function () {
        return isMilitaryExchangeGuest
            ? navigate("/myaccount/guest-order-tracking")
            : navigate(orderDetailsPath);
    };
    var showPrintReturnLabel = (allowNativeAppShippingLabel && isSufficientVersion) || !isNativeApp;
    var showMultiAddressBarcodes = isMultiAddressReturn && isUPSBarcodeEnabled && ((_c = shipments === null || shipments === void 0 ? void 0 : shipments.length) !== null && _c !== void 0 ? _c : 0) > 0;
    var onPrintShippingLabelClick = function () {
        var params = {
            trackingDetails: trackingDetails,
            orderId: orderId,
            emailId: emailId,
            isMilitaryExchangeGuest: isMilitaryExchangeGuest,
            orderDetailsV2: orderDetailsV2,
            returnTrackingNumbers: returnTrackingNumbers,
        };
        // No callbacks needed for error states as we are not showing any error messages due to how unlikely it is for shipping label to be missing in return summary page. Currently our fallback has not been used once
        executePrintShippingLabel(params, isNativeApp, militaryExchange);
    };
    var PreUPSBarcodeMessaging = (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-3" },
        React.createElement(Typography, { variant: "body-base" },
            RETURN_SUMMARY_LEGACY.RETURN_LABEL_SUB,
            React.createElement(Link, { variant: "body-base", href: "https://www.theupsstore.com/tools/find-a-store", target: "_blank" },
                ' ',
                "select UPS locations",
                ' '),
            RETURN_SUMMARY_LEGACY.RETURN_LABEL_SUB2),
        React.createElement(Typography, { variant: "body-base" }, RETURN_SUMMARY_LEGACY.RETURN_LABEL_SUB3),
        React.createElement(Typography, { variant: "body-base" },
            React.createElement("b", null, RETURN_SUMMARY_LEGACY.RETURN_LABEL_SUB4),
            React.createElement(Link, { variant: "body-base", href: "https://www.ups.com/dropoff?loc=en_US", target: "_blank", weight: "bold" }, "drop-off location?"),
            RETURN_SUMMARY_LEGACY.RETURN_LABEL_SUB5)));
    // Cant use summaryStep for UPS barcode step as it doesnt fully take up width due to flex constraints
    var UPSBarcodeMessaging = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-flex sui-gap-2" },
            React.createElement("div", null,
                React.createElement(Typography, { variant: "body-lg", weight: "bold" }, "2.")),
            React.createElement("div", { className: "sui-flex sui-flex-col" },
                React.createElement(Typography, { variant: "body-lg", weight: "bold" }, RETURN_SUMMARY.RETURN_LABEL),
                React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-6" },
                    React.createElement(Typography, { variant: "body-base" },
                        RETURN_SUMMARY.RETURN_LABEL_SUB,
                        React.createElement(Link, { variant: "body-base", href: "https://www.theupsstore.com/tools/find-a-store", target: "_blank" },
                            ' ',
                            "select UPS locations",
                            ' '),
                        RETURN_SUMMARY.RETURN_LABEL_SUB2),
                    React.createElement(Typography, { variant: "body-base" }, RETURN_SUMMARY.RETURN_LABEL_SUB3)))),
        isUPSBarcodeEnabled && (React.createElement("div", { className: "sui-ml-6 sui-mt-6" }, showMultiAddressBarcodes ? (React.createElement(MultiAddressBarcodes, null)) : (React.createElement(ViewUPSBarcodeButton, null)))),
        React.createElement("div", { className: "sui-flex sui-gap-2 sui-mt-6 sui-ml-6" },
            React.createElement(Typography, { variant: "body-base" },
                React.createElement("b", null, RETURN_SUMMARY.RETURN_LABEL_SUB4),
                showMultiAddressBarcodes ? (React.createElement(React.Fragment, null,
                    RETURN_SUMMARY.MULTI_ADDRESS_RETURN_ALT,
                    ' ',
                    React.createElement(Link, { variant: "body-base", onClick: returnToInitialPage }, "order details page."))) : (React.createElement(React.Fragment, null,
                    RETURN_SUMMARY.RETURN_LABEL_SUB5,
                    React.createElement(Link, { variant: "body-base", onClick: onPrintShippingLabelClick }, "print your label"),
                    RETURN_SUMMARY.RETURN_LABEL_SUB6))))));
    return (React.createElement("div", { className: "lg:sui-w-1/2" },
        React.createElement("div", { className: "sui-mb-6" },
            React.createElement(Typography, { variant: "h3" }, "Your next steps...")),
        React.createElement("div", { className: "sui-mb-6" },
            React.createElement(SummaryStep, { number: 1, title: RETURN_SUMMARY.PACKAGE, texts: [RETURN_SUMMARY.PACKAGE_SUB, RETURN_SUMMARY.PACKAGE_SUB2] })),
        React.createElement("div", { className: "sui-mb-6" }, isUPSBarcodeEnabled ? (UPSBarcodeMessaging) : (React.createElement(SummaryStep, { number: 2, title: RETURN_SUMMARY.RETURN_LABEL }, PreUPSBarcodeMessaging))),
        !isUPSBarcodeEnabled && showPrintReturnLabel && (React.createElement(PrintReturnLabel, { isNativeApp: isNativeApp })),
        React.createElement("div", { className: "sui-mb-9" },
            React.createElement(SummaryStep, { number: 3, title: RETURN_SUMMARY.RETURN },
                React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-3" },
                    React.createElement(Typography, { variant: "body-base" },
                        RETURN_SUMMARY.RETURN_SUB,
                        simplifiedReturnByDate &&
                            simplifiedReturnByDate !== 'Invalid Date' && (React.createElement(React.Fragment, null,
                            ' by ',
                            React.createElement("span", { className: "sui-font-bold" }, "".concat(simplifiedReturnByDate, "."))))),
                    React.createElement(Typography, { variant: "body-base" }, REFUND_TIMING_MESSAGE))))));
};
